
import {throwError as observableThrowError, Observable, throwError} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {Injectable} from '@angular/core';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from '../constants/Tpiq.constants';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogoService extends TaxplanIQServices{
    org = '';
    logoData: any = {};

    constructor(http: HttpClient) {
        super(http);
    }

    setLogoUrls(urls: any){
        this.logoData = urls;
    }

    getLogoUrls(){
      return this.logoData;
    }

    getOrg(){
        return this.org;
    }

    getLoginLogoUrl(){
        return this.logoData.loginLogoUrl ? this.logoData.loginLogoUrl : '';
    }

    getSidebarLogoUrl(){
        return this.logoData.loginLogoUrl ? this.logoData.loginLogoUrl : '';
    }

    getFaviconUrl(){
        return this.logoData.faviconUrl ? this.logoData.faviconUrl : '';
    }

    getOrgLogos(org: any): Observable<any>{
        this.org = org;
        const url = this.interpolateUrl(PATH.ORG_LOGO_SERVICE, null, {org});
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

    private handleError(error: HttpErrorResponse) {
        return throwError(error.error);
    }
}
